import isbot from 'isbot';
import { branch, compose, renderNothing, withPropsOnChange } from 'recompose';

export const withGoogleBotConsent = compose(
  withPropsOnChange([], () => ({
    isBot: isbot(window.navigator.userAgent)
  })),
  branch(({ isBot }) => isBot, renderNothing)
);
